<template>
  <div class="logo">
    <img :src="image" />
  </div>
</template>

<script>
import image from "../assets/dk.png";

export default {
  data() {
    return {
      image: image,
    };
  },
};
</script>

<style lang="scss" scoped>
.logo {
  border-radius: 50%;
  width: 50px;
  height: 50px;

  img {
    width: 50px;
    height: 50px;
  }
}
</style>
